export interface PersonalMonthlyNetLossThresholdDTO {
  active: boolean;
  disableGlobalAffordability: boolean;
  value: string;
  actions: Action[];
}

export enum Action {
  BLOCK_DEPOSIT = 'BLOCK_DEPOSIT',
  FREEZE_ACCOUNT = 'FREEZE_ACCOUNT',
}
